import styled from 'styled-components';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error ...implicitly has an 'any' type.
import FullNameInput from 'ui-addon-i18n/components/FullNameInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "ContactNotInSystemSection__StyledUIFlex",
  componentId: "sc-19fu8ug-0"
})(["display:inherit;margin-top:10px;"]);
const ContactNotInSystemSection = ({
  setFirstName,
  setLastName,
  email
}) => {
  const handleSetFirstName = e => {
    if (e.target) {
      setFirstName(e.target.value);
    }
  };
  const handleSetLastName = e => {
    if (e.target) {
      setLastName(e.target.value);
    }
  };
  return /*#__PURE__*/_jsxs(StyledUIFlex, {
    direction: "column",
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.contact-promotion-modal.emailNotFound.stepTwoLabel',
      options: {
        emailAddress: email
      }
    }), /*#__PURE__*/_jsx(FullNameInput, {
      givenNameInput: /*#__PURE__*/_jsx(UIFormControl, {
        required: true,
        children: /*#__PURE__*/_jsx(UITextInput, {
          "data-test-id": "given-name-input",
          onChange: handleSetFirstName
        })
      }),
      familyNameInput: /*#__PURE__*/_jsx(UIFormControl, {
        required: true,
        children: /*#__PURE__*/_jsx(UITextInput, {
          "data-test-id": "family-name-input",
          onChange: handleSetLastName
        })
      })
    })]
  });
};
ContactNotInSystemSection.displayName = 'ContactNotInSystemSection';
export default ContactNotInSystemSection;